import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import VueProgressBar from "@aacassandra/vue3-progressbar";
import 'vuetify/styles'

// pinia
import { resetStore } from '@/plugins/reset-store';
const pinia = createPinia();

if (!crypto.randomUUID) {
    // @ts-ignore
    crypto.randomUUID = () =>
      ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, (c: any) =>
        (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4)).toString(16)
      );
  }

pinia.use(resetStore)

// main styles
import '@/assets/styles/main.css'
//import "bootstrap-icons/font/bootstrap-icons.css"

// Global components
import ContentWithLoadingSkeleton from '@/components/ContentLoadingSkeleton/ContentWithLoadingSkeleton.vue';
import ContentWithLoadingInlineDots from '@/components/ContentLoadingSkeleton/ContentWithLoadingInlineDots.vue';
import LoadingSkeleton from '@/components/ContentLoadingSkeleton/LoadingSkeleton.vue';
import ContentWithLoadingSpinner from '@/components/ContentLoadingSkeleton/ContentWithLoadingSpinner.vue';
import LoadingSpinner from '@/components/ContentLoadingSkeleton/LoadingSpinner.vue';

// progress bar
// TODO: think about removing these options as they don't seem helpful
const progressBarOptions = {
  color: "#bffaf3",
  failedColor: "#874b4b",
  thickness: "1rem",
  transition: {
    speed: "0.2s",
    opacity: "0.6s",
    termination: 300,
  },
  autoRevert: false,
  location: "top",
  inverse: false,
  autoFinish: false
};

const isBulkRegistrationUrl = /\/bulkregistration(\/|$)/.test(window.location.pathname.toLowerCase())

async function bootstrap() {
  const app = createApp(App)

  app.use(pinia)

  // TEMPORARY HACK: Force document.readyState to always report 'complete'
  // This is needed as a temporary hack for a player-side issue where player reloads the page every 10 seconds
  // TODO: Remove this once the player-side issue is fixed
  if(isBulkRegistrationUrl) {
    (function() {
      try {
        Object.defineProperty(document, 'readyState', {
          get: function() { return 'complete'; },
          configurable: true // Allows you to delete or reset it later if needed
        });
      } catch (e) {
        console.error("Failed to mock readyState", e);
      }
    })();
  }

  // Load heavy plugins only if not on bulk registration page
  if (!isBulkRegistrationUrl) {
    const { registerHeavyPlugins } = await import('@/plugins/heavyPlugins')
    registerHeavyPlugins(app)
  }

  app.use(router)
  app.use(VueProgressBar, progressBarOptions)
  app.provide('progressBar', app.config.globalProperties.$Progress)
  app.mount('#app')
  app.component('content-with-loading-skeleton', ContentWithLoadingSkeleton);
  app.component('content-with-loading-inline-dots', ContentWithLoadingInlineDots);
  app.component('content-with-loading-spinner', ContentWithLoadingSpinner);
  app.component('loading-skeleton', LoadingSkeleton);
  app.component('loading-spinner', LoadingSpinner);
}

bootstrap()
